export default __webpack_public_path__ + "static/media/4.4d10241b.jpg";